import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiLoader, FiAward } from 'react-icons/fi';

import logoHorizontalLight from '../../assets/logos/vissory-logo-horizontal-light.svg';
import isotipoWhite from '../../assets/logos/vissory-isotipo-white.svg';
import { API } from '../../services/api';

/**
 * PublicFeaturedAgencyStandalone
 *
 * Standalone page for the featured agency, accessible without login.
 * Mirrors the `/p/:userId` public profile pattern.
 *
 * Props:
 *   PublicProfilePage – the PublicProfilePage component passed from App.js
 *                       to avoid circular imports
 *   AuthContext       – the AuthContext to provide a null-user context
 */
const PublicFeaturedAgencyStandalone = ({ PublicProfilePage, AuthContext }) => {
  const [featuredUserId, setFeaturedUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [noAgency, setNoAgency] = useState(false);

  useEffect(() => {
    axios.get(`${API}/featured-agency`)
      .then(res => {
        const userId = res.data?.user_id;
        if (!userId) setNoAgency(true);
        else setFeaturedUserId(userId);
      })
      .catch(() => setNoAgency(true))
      .finally(() => setLoading(false));
  }, []);

  const nullCtx = {
    user: null, realUser: null, token: null,
    updateUser: () => {}, notifyProjectMessaged: () => {},
    isAdmin: false, viewAsRole: 'creative',
  };

  const body = (() => {
    if (loading) {
      return (
        <div className="featured-agency-standalone-loading">
          <FiLoader className="spin" aria-hidden="true" />
        </div>
      );
    }
    if (noAgency || !featuredUserId) {
      return (
        <div className="featured-agency-standalone-empty">
          <FiAward className="featured-agency-empty-icon" aria-hidden="true" />
          <h2 className="featured-agency-empty-title">Agencia Destacada</h2>
          <p className="featured-agency-empty-text">
            Aún no hay una agencia destacada. ¡Inicia sesión y sé la primera!
          </p>
        </div>
      );
    }
    return (
      <PublicProfilePage
        userId={featuredUserId}
        isFeaturedAgency
      />
    );
  })();

  return (
    <AuthContext.Provider value={nullCtx}>
      <div className="public-profile-standalone">
        <header className="public-profile-standalone-header">
          <a href="/" className="public-profile-standalone-logo" aria-label="Ir al inicio">
            <img src={logoHorizontalLight} alt="Vissory" className="public-profile-standalone-logo-img" />
          </a>
          <nav className="public-profile-standalone-nav">
            <a href="/" className="public-profile-standalone-login">Iniciar sesión</a>
            <a href="/" className="public-profile-standalone-register">Crear cuenta gratis</a>
          </nav>
        </header>
        <div className="public-profile-standalone-body">
          {body}
        </div>
        <div className="public-profile-standalone-cta-bar">
          <div className="public-profile-standalone-cta-inner">
            <div className="public-profile-standalone-cta-text">
              <img src={isotipoWhite} alt="" className="public-profile-standalone-cta-iso" />
              <div>
                <strong>Únete a Vissory</strong>
                <span>Conecta con los mejores creativos, gestiona proyectos y haz crecer tu marca.</span>
              </div>
            </div>
            <a href="/" className="public-profile-standalone-cta-btn">Crear cuenta gratis</a>
          </div>
        </div>
      </div>
    </AuthContext.Provider>
  );
};

export default PublicFeaturedAgencyStandalone;
